import { CommentsWidgetApi } from './comments-widget-api';
import { distinctUntilChanged } from 'rxjs/operators';
import { Subject } from 'rxjs'

class CommentsWidget {
    constructor(api = new CommentsWidgetApi()) {
        this._el = null;
        this._api = api;
        this._countSubscriber = null;
        this._onClick = null;
        this.createPlaceHolder();
    }
    init() {

        this.api.init();
        this.linkEl.addEventListener('click', this.handleClick.bind(this));
        this.countSubscriber = this.api.state.pipe(distinctUntilChanged(null, state => {
            return state.count;
        })).subscribe((state) => {
            this.handleCountChange(state.count);
        })

    }
    get countSubscriber() {
        return this._countSubscriber;
    }
    set countSubscriber(subsciription = null) {
        this._countSubscriber = subsciription;
    }
    get el() {
        if (this._el == null) {
            let el = document.createElement('div');
            el.classList.add('medscape-comments-widget');
            this._el = el;
        }
        return this._el;
    }
    get onClick() {
        if (this._onClick == null) {
            this._onClick = new Subject();
        }
        return this._onClick;
    }
    get api() {
        return this._api;
    }
    set api(api) {
        this._api = api;
    }

    handleCountChange(count = 0) {}
    handleClick(e) {
        this.onClick.next(e);
    }
    createPlaceHolder() {

        if (document.querySelector('.viafoura-commentcount') == null && typeof window.vfUuid != 'undefined') {
            let placeHolderEl = document.createElement('div');
            placeHolderEl.classList.add('viafoura-commentcount');
            placeHolderEl.setAttribute('data-vf-section-uuid', window.vfUuid);
			placeHolderEl.setAttribute('data-vf-article-id', (PageMetadata.pageSegVars.art == '0' ? window.location.pathname.match(/\d+$/)[0] : PageMetadata.pageSegVars.art));
            placeHolderEl.style.display = "none";
            document.body.appendChild(placeHolderEl);
        }
    }

}

export { CommentsWidget }